/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QueueResponse } from '../../models/queue-response';

export interface CasesQueueGet$Params {
  pageSize?: (number | string);
  caseType?: string;
  cursor?: string;
}

export function casesQueueGet(http: HttpClient, rootUrl: string, params?: CasesQueueGet$Params, context?: HttpContext): Observable<StrictHttpResponse<QueueResponse>> {
  const rb = new RequestBuilder(rootUrl, casesQueueGet.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('caseType', params.caseType, {});
    rb.query('cursor', params.cursor, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QueueResponse>;
    })
  );
}

casesQueueGet.PATH = '/cases/queue';
